import React, { useState } from 'react';

function Image({
  src,
  alt = "Image Name",
  className = "",
  ...props
}) {
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const handleError = (e) => {
    if (!hasError) {
      setHasError(true);
      e.target.src = "/assets/images/no_image.png";
    }
  };

  const handleLoad = () => {
    setIsLoading(false);
  };

  return (
    <img
      src={hasError ? "/assets/images/no_image.png" : src}
      alt={alt}
      className={className}
      onError={handleError}
      onLoad={handleLoad}
      {...props}
    />
  );
}

export default Image;
